import { FMFile } from "../shared/FMFile";
import Utils from "../libs/Utils";
import React, { ReactElement } from "react";
import { useFileMenu } from "./FileMenu";
import Usernames from "../fmanlibs/Usernames";
import { usePath } from "../libs/path/PathProvider";
import _ from "lodash";
import FolderIcon from "./Icons/FolderIcon";
import PhotoIcon from "./Icons/PhotoIcon";
import DocumentIcon from "./Icons/DocumentIcon";
import InventoryIcon from "./Icons/InventoryIcon";
import Checkbox from "../gui/Button/Checkbox";
import { UpdateEvent } from "../gui/GUIEvents";
import { useSelectionProvider } from "../fmanlibs/SelectionProvider";
import Table from "../gui/Table/Table";

const COLS = ["name","updated","size","createdBy"]
const LABELS : Record<string,string> = {
    name:"Name",
    updated:"Date modified",
    size:"Size",
    createdBy:"Owner"
}

const G = 1_000_000_000
const M = 1_000_000
const K = 1_000

function size(val:number){
    if (val>=G) return (val/G).toFixed(2)+" GB"
    else if (val>M) return (val/M).toFixed(2)+" MB"
    else if (val>K) return (val/K).toFixed(2)+" KB"
    else return val
}

function FileName(props:{file:FMFile,selected:boolean,onToggle:(selected:boolean)=>void}) {
    const {file,selected,onToggle} = props
    const {setPath} = usePath()

    let icon:ReactElement
    let click:any = {}

    const onClick = (e:any) => setPath(`/${file._id}`)
    if (FMFile.isDir(file)) {
        icon = <FolderIcon/>
        click = {onClick}
    }
    else if (FMFile.isImage(file)) icon = <PhotoIcon/>
    else if (FMFile.isText(file)) icon = <DocumentIcon/>
    else icon = <InventoryIcon/>
    
    const onDragStart = (e:React.DragEvent) => { console.log("start",e); e.dataTransfer.setData("DownloadURL", `text/html:${props.file.name}:${document.location.href}`)}
    const onDropEnd = (e:React.DragEvent) => { console.log("end", e)}

    return <div className="filename flex middle gap-4" {...click}>
        <Checkbox size="small" value={selected} onUpdate={e=>onToggle(e.value!)} preventDefault/>
        {icon} 
        <div draggable onDragStart={onDragStart} onDragEnd={onDropEnd}>{props.file.name}</div>
    </div>
}

export default function FileList(props:{files:FMFile[]}) {
    const {setPath} = usePath()
    const {selected,addFile,removeFile,addFiles,removeAll,isSelected} = useSelectionProvider()
    const {openFileMenu} = useFileMenu()

    const value = (row:FMFile, col:string) => {
        switch(col){
        case "size":        return FMFile.isDir(row) ? "" : size(row.size)
        case "updated":     return Utils.formatDate("yyyy-MM-dd hh:mm ampm", new Date(row.updated))
        case "createdBy":   return Usernames.i.row(row.createdBy)?.text || ""
        default:            return (row as any)[col]
        }
    }
    const onToggleAll = (e:UpdateEvent<boolean>) => {
        if (e.value) addFiles(props.files)
        else removeAll()
    }
    const label = (col:string) => {
        if (col=="name") return <><Checkbox className="label" size="small" onUpdate={onToggleAll} value={selected.length>0 && selected.length==props.files.length} preventDefault/>Name</>
        return LABELS[col]
    }
    const th = (col:string) => col=="size" ? {className:"align-right"} : {}
    const sort = (left:FMFile,right:FMFile,col:string,dir:number) => {
        const lDir = FMFile.isDir(left), rDir = FMFile.isDir(right)
        if (lDir && !rDir) return -dir
        else if (rDir && !lDir) return dir
        return value(left, col) < value(right,col) ? -dir : dir
    }
    const onOpen = (file:FMFile) => (e:any) => {
        e.preventDefault()
        FMFile.isDir(file) && setPath(`/${file._id}`)
    }
    const rowProps = (row:FMFile) => ({onContextMenu:onContextMenu(row), onDoubleClick:onOpen(row)})
    const onToggle = (row:FMFile) => (on:boolean) => on ? addFile(row) : removeFile(row)
    const cellRenderer = (row:FMFile, col:string) => {
        if (col=="name") return <FileName file={row} selected={isSelected(row)} onToggle={onToggle(row)}/>
        else return value(row, col)
    }
    const onContextMenu = (row:FMFile) => (e:any) => openFileMenu(e, row)
    const rowKey = (row:FMFile) => row._id
    return <div id="filelist">
        <div className="filesContainer">
            <Table tableName="files" rows={props.files} tr={rowProps} th={th} cellText={cellRenderer} cols={COLS} label={label} rowKey={rowKey} rowcmp={sort}/>
        </div>
    </div>
}